import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title d-flex align-items-center justify-content-between w-100" }
const _hoisted_2 = { class: "fs-5 mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mas fw-light" }, "refresh", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_ProductSelectionBaseSyncHistoryContent = _resolveComponent("ProductSelectionBaseSyncHistoryContent")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, {
      "container-fluid": "",
      "has-build-status-on-page": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('pharmacySoftware'),
          mb: 3
        }, null, 8, ["title"]),
        (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC'))
          ? (_openBlock(), _createBlock(_component_base_card, {
              key: 0,
              class: "pharmacy-software mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('synchronisationHistory')), 1),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args)), ["prevent"])),
                        class: "btn btn-hover"
                      }, _hoisted_4)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_ProductSelectionBaseSyncHistoryContent, {
                      "external-system-type-code": "PHARMACY_SW",
                      key: _ctx.contentKey
                    }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}